module.exports = __webpack_public_path__ + "static/media/denuncia_new.42d3bff4.svg";